const SECTORS = [
    "Consumer Goods",
    "Electronics",
    "Personal Care",
    "Food & Beverage",
    "Industrial Supplies",
    "Home & Living",
    "Health & Wellness",
    "Apparel"
];

export default function TrustStrip() {
    return (
        <section aria-label="Sectors we serve" className="border-y border-border bg-muted/40">
            <div className="container-px mx-auto max-w-7xl py-6 lg:py-7">
                <div className="flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-10">
                    <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground font-medium shrink-0">
                        Sectors we focus on
                    </p>
                    <div className="relative overflow-hidden flex-1">
                        <div className="flex gap-8 lg:gap-12 animate-marquee whitespace-nowrap will-change-transform">
                            {[...SECTORS, ...SECTORS].map((s, i) => (
                                <span
                                    key={`${s}-${i}`}
                                    className="font-display text-sm lg:text-base font-medium text-foreground/80"
                                >
                                    {s}
                                </span>
                            ))}
                        </div>
                        <div className="pointer-events-none absolute inset-y-0 left-0 w-12 bg-gradient-to-r from-muted/80 to-transparent" />
                        <div className="pointer-events-none absolute inset-y-0 right-0 w-12 bg-gradient-to-l from-muted/80 to-transparent" />
                    </div>
                </div>
            </div>
        </section>
    );
}
